import { Modal  }                          from 'rewire-ui';
import areaSettingsDialogAdvancedViewModel from './AreaSettingsDialogAdvancedViewModel';
import areaSettingsDialogGeneralViewModel  from './AreaSettingsDialogGeneralViewModel';
import areaSettingsDialogMembersViewModel  from './AreaSettingsDialogMembersViewModel';

export enum AreaSettingsViewType {
  General = 'General',
  Members = 'Members',
  Advanced = 'Advanced',
}

export interface IAreaSettingsDialogState {
  view: AreaSettingsViewType;
}

export class AreaSettingsDialogModel extends Modal<IAreaSettingsDialogState> {
  areaId?: string;

  constructor() {
    super('Area Settings');
    this.state.view = AreaSettingsViewType.General;
  }

  reset() {
    this.areaId = undefined;
  }

  load(areaId: string) {
    this.areaId = areaId;
    areaSettingsDialogGeneralViewModel.load(areaId);
    areaSettingsDialogMembersViewModel.load(areaId);
    areaSettingsDialogAdvancedViewModel.load(areaId);
    this.open();
  }

  get view(): AreaSettingsViewType {
    return this.state.view;
  }

  isView(view: AreaSettingsViewType): boolean {
    return this.state.view === view;
  }

  setView(view: AreaSettingsViewType) {
    this.state.view = view;
  }
}

const areaSettingsDialogModel = new AreaSettingsDialogModel();
export default areaSettingsDialogModel;
